import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star, Shield, Lock, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
const PLANS = [{
  id: 'basic',
  icon: '📘',
  name: 'SISTEMA CICLISTA PRO',
  tagline: '6 Tomos + 6 Bonos',
  originalPrice: '$27.990',
  price: '$19.990',
  url: 'https://tumanualdigital.com/cart/44182624534564:1',
  features: ['6 Tomos completos (ruta y MTB)', '6 Bonos siempre incluidos', 'Actualizaciones de por vida']
}, {
  id: 'premium',
  icon: '🏆',
  name: 'SISTEMA + MASTER-PLAN 365',
  tagline: 'Todo + Cronograma anual de resultados',
  originalPrice: '$49.990',
  price: '$27.990',
  url: 'https://tumanualdigital.com/cart/44182625648676:1',
  features: ['Todo lo del Sistema Ciclista Pro', 'Master-Plan 365 (GPS de implementación)', 'Calendario Maestro de 52 Semanas', 'Calculadora de ROI y ahorro mensual'],
  featured: true
}];
export function PricingCards() {
  const [selectedId, setSelectedId] = useState('premium');
  const selected = PLANS.find(p => p.id === selectedId) ?? PLANS[1];
  return <section className="py-6 md:py-12 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-278">
      <FadeIn data-id="element-279">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-1 md:mb-2 tracking-tight text-[#0f172a]" data-id="element-280">
          ELEGÍ TU SISTEMA
        </h2>
        <p className="text-center text-[#475569] font-medium text-sm md:text-base mb-5 md:mb-8" data-id="element-281">
          Tocá la opción que querés y presioná el botón
        </p>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-282">
        <div className="max-w-3xl mx-auto" data-id="element-283">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-5 md:mb-6" data-id="element-284">
            {PLANS.map(plan => {
            const isSelected = plan.id === selectedId;
            return <button key={plan.id} type="button" onClick={() => setSelectedId(plan.id)} aria-pressed={isSelected} className={`relative text-left rounded-2xl p-4 md:p-5 transition-all duration-200 ${isSelected ? 'bg-white border-2 border-[#22c55e] shadow-[0_10px_30px_rgba(34,197,94,0.2)] scale-[1.02]' : 'bg-white border-2 border-[#e2e8f0] hover:border-[#22c55e]/50 opacity-80 hover:opacity-100'}`} data-id="element-285">
                  {plan.featured && <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#22c55e] to-[#4ade80] text-[#020617] font-black px-3 py-0.5 rounded-full text-[10px] md:text-xs flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-286">
                      <Star className="w-3 h-3" fill="currentColor" data-id="element-287" /> MÁS
                      ELEGIDO
                    </div>}

                  {/* Radio indicator */}
                  <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'bg-[#22c55e] border-[#22c55e]' : 'bg-white border-[#cbd5e1]'}`} data-id="element-288">
                    {isSelected && <Check className="text-white w-3 h-3" strokeWidth={4} data-id="element-289" />}
                  </div>

                  <div className="pr-7 pt-2" data-id="element-290">
                    <h3 className="text-sm md:text-base font-black text-[#0f172a] flex items-center gap-1.5 mb-1 leading-tight" data-id="element-291">
                      <span className="text-base md:text-lg" data-id="element-292">{plan.icon}</span>
                      {plan.name}
                    </h3>
                    <p className="text-[11px] md:text-xs text-[#475569] font-bold mb-2.5" data-id="element-293">
                      {plan.tagline}
                    </p>

                    <div className="flex items-baseline gap-2 mb-3" data-id="element-294">
                      <span className="text-[#ef4444] line-through text-xs font-bold" data-id="element-295">
                        {plan.originalPrice}
                      </span>
                      <span className={`text-2xl md:text-3xl font-black ${plan.featured ? 'text-[#16a34a]' : 'text-[#0f172a]'}`} data-id="element-296">
                        {plan.price}
                      </span>
                      <span className="text-[11px] text-[#475569] font-bold" data-id="element-297">
                        ARS
                      </span>
                    </div>

                    <ul className="space-y-1" data-id="element-298">
                      {plan.features.map((f, i) => <li key={i} className="flex items-start gap-1.5 text-[11px] md:text-xs text-[#0f172a] font-medium" data-id="element-299">
                          <Check className="text-[#22c55e] mt-0.5 shrink-0" size={12} strokeWidth={3} data-id="element-300" />
                          <span data-id="element-301">{f}</span>
                        </li>)}
                    </ul>
                  </div>
                </button>;
          })}
          </div>

          {/* Shared CTA */}
          <motion.a key={selected.id} initial={{
          opacity: 0.7,
          y: 5
        }} animate={{
          opacity: 1,
          y: 0
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href={selected.url} className="w-full block text-center py-4 md:py-5 px-4 rounded-xl font-black text-base md:text-lg bg-[#22c55e] hover:bg-[#4ade80] text-[#020617] transition-colors shadow-[0_10px_30px_rgba(34,197,94,0.35)]" data-id="element-302">
            → COMPRAR {selected.name} · {selected.price} ARS
          </motion.a>

          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-4 text-xs md:text-sm text-[#475569] font-medium" data-id="element-303">
            <span className="flex items-center gap-1.5" data-id="element-304">
              <Shield size={14} className="text-[#22c55e]" data-id="element-305" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-306">
              <Lock size={14} className="text-[#22c55e]" data-id="element-307" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-308">
              <Zap size={14} className="text-[#22c55e]" data-id="element-309" /> Acceso en 5 min
            </span>
          </div>
        </div>
      </FadeIn>
    </section>;
}